import { render, staticRenderFns } from "./InvestorsSupport.vue?vue&type=template&id=2808605a&scoped=true&"
import script from "./InvestorsSupport.vue?vue&type=script&lang=ts&"
export * from "./InvestorsSupport.vue?vue&type=script&lang=ts&"
import style0 from "./InvestorsSupport.vue?vue&type=style&index=0&id=2808605a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2808605a",
  null
  
)

export default component.exports